import React from "react"

const shloka_shinde = () => {
    return (
        <div>
<h1>Shloka Shinde</h1>

<h4>Computer Engineering, Batch of 27'<br/><hr/></h4>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?</p>

<p>The initial shortlisting involved multiple steps. After applying through Superset, we received an email from Accenture on our personal email IDs, where we were required to upload our resumes. Following this, access to the iAspire portal was provided. A key eligibility requirement was to complete the courses on the portal and earn a Gold Medal (minimum <strong>2250 XP points</strong>).</p>

<p>Candidates who fulfilled this requirement received a shortlisting email (likely based on a combination of course completion and <strong>resume screening</strong>). The XP requirement was achievable within 1–2 days with focused effort.</p>

<p><strong>What was the Timeline of the entire Interview Process</strong>?<br />
Since this was an <strong>on-campus</strong> <strong>Pan-India internship drive</strong>, the process was relatively long and conducted in multiple stages: </p>

<ol>
<li>Completion of courses on portal, resume screening  </li>
<li>Three Assessment rounds  </li>
<li>Communication assessment   </li>
<li>Virtual interview </li>
</ol>

<p>Each stage had a gap of a few days, making the overall process span across a couple of weeks.</p>

<p><strong>What was the Structure of the Aptitude Round?</strong><br />
The aptitude round was divided into three parts:</p>

<p><strong>1. Behavioral &amp; Cognitive Assessment (Gamified):</strong></p>

<ul>
<li>Cognitive: Memory-based games, quick-fire math questions, grid-based path optimization puzzles  </li>
<li>Behavioral: Situational and personality-based questions  </li>
<li>Duration: 40 minutes</li>
</ul>

<p><strong>2. Technical Assessment (MCQs):</strong></p>

<ul>
<li>Focus: Java, Python, OOPs, OS, CN, DSA  </li>
<li>Duration: 45 minutes</li>
</ul>

<p><strong>3. Coding Round:</strong></p>

<ul>
<li>3 questions:  
<ul>
<li>1 DSA question  </li>
<li>1 SQL question  </li>
<li>1 Frontend task (modifying HTML, CSS, JavaScript)  </li>
</ul></li>
<li>Duration: 60 minutes</li>
</ul>

<p>Each of these was an eliminatory round conducted on the same day, and candidates received communication for the subsequent round only after successfully clearing the previous one.</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
Since this was a <strong>Pan-India hiring process</strong>, the exact number of shortlisted candidates was not disclosed.</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
There was a gap of a few days between each stage. During this time, I focused on revising core subjects, while also practicing DSA problems regularly. I also thoroughly reviewed my projects and internships. Additionally, I prepared for HR and behavioral questions to ensure I was well-rounded for the upcoming rounds.</p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong><br />
There were <strong>two main stages after assessments</strong>:</p>

<p><strong>1. Communication Assessment (Eliminatory):</strong></p>

<ul>
<li>Duration: 30 minutes  </li>
<li>2 sections : Verbal and Written communication</li>
</ul>

<p><strong>2. Virtual Interview (Technical + HR):</strong></p>

<p>The interview began with a brief introduction, after which the focus shifted to my internships and project experience. I was asked to explain my internship project in detail, followed by several in-depth questions, including questions around agentic AI. The interviewer then asked about my favorite programming language (Java, in my case) and tested my understanding of OOP concepts through follow-up questions. Since I had mentioned MERN stack projects in my resume and the interviewer had significant experience in that area, I was also asked questions related to React.js. Additionally, there were questions about any research work I had undertaken. The discussion further covered my role in group projects, challenges I had faced, and how I handled failure, including a specific instance. The interviewer also asked about my favorite and least favorite subjects and how I improved in the latter, along with common HR questions such as where do I see myself in the next five years. The round concluded with questions focusing on my strengths, weaknesses, and leadership experiences.</p>

<p><strong>What Topics or Skills did the interviewers focus on during the interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or Behavioral questions)</strong><br />
The interview primarily focused on projects and internships, core programming concepts (especially Java and OOPs), fundamental CS knowledge, practical understanding, and HR aspects including awareness of AI tools.</p>

<p><strong>What are some good resources that you used in your Internship Prep?</strong><br />
I referred to Kunal Kushwaha’s playlist for Java, Striver’s Sheet and LeetCode for DSA, CodeHelp by Babbar for DBMS and OS, Gate Smashers for Computer Networks and GFG last-minute notes for quick revision.</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
Break complex problems into smaller parts, write clean and readable code with proper naming, manage your time effectively, and don’t hesitate to ask for hints if stuck for a few minutes. </p>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?<br />
The interview was majorly resume based with significant focus on projects and internships. Towards the end, the interviewer also briefly discussed my extracurricular activities and leadership roles.</p>

<p><strong>Is there something specific that you would want to tell people who are preparing for the same company</strong>?<br />
Do not ignore the Accenture portal courses as completing them is crucial for shortlisting.<br />
Keep checking your personal email (including spam) regularly for updates.<br />
Be thorough with your resume as anything mentioned can be asked in depth.<br />
Also, be patient with the emails as there can be a significant delay after each round but that’s just how their process works.</p>

<p><strong>Any Final Tips for Juniors?</strong><br />
It’s completely okay to face multiple rejections but don’t let them shake you. I know it sounds cliché and honestly feels annoying when you’re in the middle of it, especially when it seems like everyone around you is getting an internship before you, but have faith in yourself and stay consistent with your efforts. Trust me, the day things work out, it’ll all feel worth it.</p>

<p><strong>Contact Info (these will be shared in the diary, you are free to not share any specific one)</strong><br />
<strong>Email :</strong> <a href="mailto:shlokass23.comp@coeptech.ac.in">shlokass23.comp@coeptech.ac.in</a><br />
<strong>LinkedIn :</strong> <a href="https://www.linkedin.com/in/shlokashinde/">Shloka Shinde</a></p>


<hr />

        </div>
    )
}

export default shloka_shinde
